import type { BrandRegionCode } from "core/entities";
import { getBrand } from "../utils/getBrand";
import { useRegion } from "./useRegion";

export function useBrandRegionCode(): BrandRegionCode {
  const { brandCode } = getBrand();
  const region = useRegion();
  return `${brandCode}${region}` as BrandRegionCode;
}
